import React, { Fragment } from 'react';
import { Grid } from '@mui/material';
import { useLazyQuery } from '@apollo/client';
import { StatusBar } from 'components';
import withGraphQL from 'containers/withGraphQL.hoc';
import { STATUS_BAR_ITEMS } from 'models/constants';
import { CUSTOMER_PROFILE_QUERY } from 'models/queries';
import CustomerProfileLoading from './CustomerProfileLoading';
import StyledGridContainer from './styles';
import CustomerProfile from './CustomerProfile';
var CustomerProfileContainer = function (_a) {
    var lmktId = _a.lmktId, _b = _a.hasFilter, hasFilter = _b === void 0 ? false : _b, _c = _a.statusActiveIndex, statusActiveIndex = _c === void 0 ? -1 : _c, _d = _a.onFilter, onFilter = _d === void 0 ? function () { return null; } : _d;
    var _e = useLazyQuery(CUSTOMER_PROFILE_QUERY), getCustomerData = _e[0], loading = _e[1].loading;
    return (React.createElement(StyledGridContainer, { container: true, p: 2 }, loading ? (React.createElement(CustomerProfileLoading, null)) : (React.createElement(Fragment, null,
        statusActiveIndex >= 0 ? (React.createElement(Grid, { item: true, component: "section", mb: 2 },
            React.createElement(StatusBar, { activeIndex: statusActiveIndex, items: STATUS_BAR_ITEMS }))) : null,
        React.createElement(Grid, { item: true },
            React.createElement(CustomerProfile, { getCustomerData: getCustomerData, hasFilter: hasFilter, lmktId: lmktId, onFilter: onFilter }))))));
};
export default withGraphQL(CustomerProfileContainer);
//# sourceMappingURL=CustomerProfileContainer.js.map